import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, HttpApiQueryRepository, Query, QueryResult } from '@softline/core';
import { QueryDataSource } from '@softapps/core';
import { SOFTLINE_API_ABC_ANALYSIS_PRODUCT_DETAIL } from '../abc-analysis.api';
import { AbcAnalysisProductDetailMaster } from '../types/abc-analysis-master';
import { AbcAnalysisProductDetailRow } from '../types/abc-analysis-product-detail-row';

@Injectable()
export class AbcAnalysisProductDetailGridService
  extends HttpApiQueryRepository<AbcAnalysisProductDetailRow, AbcAnalysisProductDetailMaster>
  implements QueryDataSource<AbcAnalysisProductDetailRow>
{
  type = 'query' as const;

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ABC_ANALYSIS_PRODUCT_DETAIL);
  }

  protected override getLoadPathParams(params: {
    query: Query<AbcAnalysisProductDetailRow>;
    master?: AbcAnalysisProductDetailMaster;
  }): Dictionary<unknown> | undefined {
    return {
      baseMeasure: params.master?.baseMeasure,
      abcAnalysisId: params.master?.abcAnalysisId,
      productNumber: params.master?.productNumber,
    };
  }

  // The backend always returns all columns regardless of this payload, and ignores sort
  // params — results are always ordered by A/B/C bucket internally.
  protected override getLoadPayload(params: {
    query: Query<AbcAnalysisProductDetailRow>;
    master?: AbcAnalysisProductDetailMaster;
  }): unknown {
    return { ...params.query, columns: [] };
  }

  override load(params: {
    query: Query<AbcAnalysisProductDetailRow>;
    master?: AbcAnalysisProductDetailMaster;
  }): Promise<QueryResult<AbcAnalysisProductDetailRow> & { lastRow: number }> {
    return super.load(params) as Promise<
      QueryResult<AbcAnalysisProductDetailRow> & { lastRow: number }
    >;
  }
}
